module.exports = __webpack_public_path__ + "static/media/no-data.1f599014.jpg";